class productSuggestionController {

    /* @ngInject */
    constructor(environment) {
        this.environment = environment;
    }
    
    $onInit() {
        this.expandSuggestions = true;

        // Dummy list for prototyping
        this.list = [5,6,7,8];
    }

    toggleSuggestions() {
        this.setExpandSuggestions(!this.expandSuggestions);
    }

    setExpandSuggestions(flag) {
        this.expandSuggestions = flag;
    }

    addProduct(event) {
        var element = angular.element(document.querySelector('#' + event.target.id));

        if(!element.hasClass('added')) {

            element.addClass('added');
            element.find('span.plus').addClass('hide');
            element.find('span.check').addClass('show');
        }
    }
}

export default productSuggestionController;


// WEBPACK FOOTER //
// ./src/app/common/product-suggestion/product-suggestion.controller.js